import { Header } from "@/components/public/Header";
import { Footer } from "@/components/public/Footer";

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-white flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
